<template>
  <div class="pages-banks-acquiring">
    <BundlesPage />
  </div>
</template>

<style scoped lang="scss">
.pages-banks-acquiring {
  padding-top: em($gap-page-title);
  padding-bottom: em(139);

  @include media-breakpoint-down(sm) {
    padding-top: em($gap-page-title-sm);
    padding-bottom: em(69);
  }

  @include bundles-constructor-section {
    &:nth-child(1) {
      margin-bottom: em(64);

      @include media-breakpoint-down(sm) {
        margin-bottom: em(26);
      }
    }

    &:nth-child(2) {
      margin-bottom: em(143);

      @include media-breakpoint-down(sm) {
        margin-bottom: em(65);
      }
    }

    &:nth-child(3) {
      margin-bottom: em(103);

      @include media-breakpoint-down(sm) {
        margin-bottom: em(36);
      }
    }

    &:nth-child(4) {
      @include ctr-sidebar-section {
        &:nth-child(1),
        &:nth-child(2) {
          margin-bottom: em(136);

          @include media-breakpoint-down(sm) {
            margin-bottom: em(59);
          }
        }
      }
    }
  }
}
</style>
